const foodcategory = {
  getlist: 'foodcategory/getlist',
  add: 'foodcategory/add',
  update: 'foodcategory/update',
  remove: 'foodcategory/remove',
  get: 'foodcategory/get',
  getall: 'foodcategory/getall',
  clearcache: 'foodcategory/clear-cache',
}
export default foodcategory
